<div class="user-item">
  <div class="user-item__column">
    <strong>{{ data.incidentId }}</strong>
  </div>
  <div class="user-item__column">
    <strong>{{ data.createdOn | date : "dd/MM/yyyy" }}</strong>
  </div>
  <div class="user-item__column">
    <strong>{{ data.subCell || "-" }}</strong>
  </div>
  <div class="user-item__column status">
    <strong
      [ngClass]="{
        green: data.status === IncidentsDetailStatusEnum.Processed,
        red: data.status === IncidentsDetailStatusEnum.Error,
        blue: data.status === IncidentsDetailStatusEnum.Processing,
        grey: data.status === IncidentsDetailStatusEnum.WaitingForProcessing
      }"
    >
      {{ data.status || "-" }}
    </strong>
    <app-tooltip
      *ngIf="data.status === IncidentsDetailStatusEnum.Error"
      [tipo]="'erro'"
    >
      <div class="tooltip-icon">
        <img src="../../../assets/icons/error-warning-line.svg" alt="Erro" />
      </div>
      <span tooltip-text>{{ data.errorMessage }}</span>
    </app-tooltip>
  </div>
</div>
